import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/layout/page-container';
import { PageHeader } from '@/components/layout/page-header';
import { ChangePasswordForm } from './-components/change-password-form';
import { UpdateNameForm } from './-components/update-name-form';

export const Route = createFileRoute('/_authenticated/_global/user-settings/')({
  component: UserSettingsComponent,
});

function UserSettingsComponent() {
  return (
    <PageContainer className="max-w-2xl">
      <PageHeader title="Account Settings" description="Manage your personal settings" />
      <div className="grid gap-6">
        <UpdateNameForm />
        <ChangePasswordForm />
      </div>
    </PageContainer>
  );
}
